<ng-container *ngIf="formControlValue == null; else toggleWithFormControl">
    <label class="custom-toggle" [class.disabled]="disabled" (click)="onLabelClick($event)">
        <input type="checkbox" (change)="onToggleChange($event)" [disabled]="disabled" [checked]="checked" />
        <span class="slider"></span>
        {{ caption }}
    </label>
</ng-container>

<ng-template #toggleWithFormControl>
    <label class="custom-toggle" [class.disabled]="disabled" (click)="onLabelClick($event)">
        <input
            type="checkbox"
            [formControl]="formControlValue"
            (change)="onToggleChange($event)"
            [disabled]="disabled"
        />
        <span class="slider"></span>
        {{ caption }}
        <ng-content></ng-content>
    </label>
</ng-template>
